export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.8.26-1256.12",
  commitId: "ce99a61c8c698e1b2f0cb618bdd02082b6a26225",
  commitTime: "2026-08-26T12:56:12.000Z",
});
